import React from 'react';
import MiniKPI from './MiniKPI';

/**
 * items: Array of { label, value, icon?, colClass? ('col-md-3' default), right? (ReactNode) }
 * className: extra classes for the row
 */
const SummaryRow = ({ items = [], className = '' }) => (
  <div className={`row ${className}`}>
    {items.map((it, idx) => (
      <div key={idx} className={`${it.colClass || 'col-md-3'} col-sm-6`}>
        <MiniKPI
          label={it.label}
          value={it.value}
          icon={it.icon}
          right={it.right}
        />
      </div>
    ))}
  </div>
);

export default SummaryRow;
